module.exports = __webpack_public_path__ + "static/media/encoding_hybrid.de06cea5.png";